import { render, staticRenderFns } from "./gameSelect.vue?vue&type=template&id=aa1f45aa&"
import script from "./gameSelect.vue?vue&type=script&lang=js&"
export * from "./gameSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa1f45aa')) {
      api.createRecord('aa1f45aa', component.options)
    } else {
      api.reload('aa1f45aa', component.options)
    }
    module.hot.accept("./gameSelect.vue?vue&type=template&id=aa1f45aa&", function () {
      api.rerender('aa1f45aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/selectComponents/gameSelect.vue"
export default component.exports